const budgetStatuses = [
  {
    id: '0',
    name: '予算未設定'
  },
  {
    id: '1',
    name: '未入金'
  },
  {
    id: '2',
    name: '入金済'
  }
];

export default budgetStatuses;
